import { BUSINESS_CONTEXTS, normalizeBusinessContexts } from 'dashboard/constants/lais';
import { PROPERTY_OFFER_BUSINESS_CONTEXT } from 'dashboard/constants/lais/offer';

export const agentWorksWithSales = contexts =>
  normalizeBusinessContexts(contexts).includes(BUSINESS_CONTEXTS.FOR_SALE);

export const agentWorksWithRent = contexts =>
  normalizeBusinessContexts(contexts).includes(BUSINESS_CONTEXTS.FOR_RENT);

const houseForSale = house =>
  Boolean(
    house?.forSale ||
      house?.for_sale ||
      house?.finalidade === 'venda' ||
      house?.business_context === PROPERTY_OFFER_BUSINESS_CONTEXT.PURCHASE ||
      house?.businessContext === PROPERTY_OFFER_BUSINESS_CONTEXT.PURCHASE
  );

const houseForRent = house =>
  Boolean(
    house?.forRent ||
      house?.for_rent ||
      house?.finalidade === 'aluguel' ||
      house?.business_context === PROPERTY_OFFER_BUSINESS_CONTEXT.RENTAL ||
      house?.businessContext === PROPERTY_OFFER_BUSINESS_CONTEXT.RENTAL
  );

export const isAgentAllowedForHouse = (house, contexts) => {
  if (!house) return false;
  return (
    (houseForSale(house) && agentWorksWithSales(contexts)) ||
    (houseForRent(house) && agentWorksWithRent(contexts)) ||
    (!houseForSale(house) && !houseForRent(house))
  );
};
